import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-warn-button-loader',
  templateUrl: './warn-button-loader.component.html',
  styleUrls: ['./warn-button-loader.component.scss']
})
export class WarnButtonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
